import { render, staticRenderFns } from "./SettingPickerWidth.vue?vue&type=template&id=74e4b63f&"
import script from "./SettingPickerWidth.vue?vue&type=script&lang=js&"
export * from "./SettingPickerWidth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports